import type { InvestmentState } from "@/domain/investment/types";
import type { InvestorType } from "@/domain/investor";

interface InvestmentFilterFields {
  state?: InvestmentState | InvestmentState[];
  investor_type?: InvestorType | InvestorType[];
  investor_uuid?: string;
  beneficiary_uuid?: string;
  fiscal_quota_uuid?: string;
  fiscal_year?: number | string;
}

const asList = <T>(value: T | T[] | undefined): T[] | undefined =>
  value === undefined ? undefined : Array.isArray(value) ? value : [value];

export function toInvestmentFilterQuery<T extends InvestmentFilterFields>(params: T) {
  const {
    state,
    investor_type,
    investor_uuid,
    beneficiary_uuid,
    fiscal_quota_uuid,
    fiscal_year,
    ...rest
  } = params;
  return {
    ...rest,
    state: asList(state),
    investor_type: asList(investor_type),
    investor_uuid: asList(investor_uuid),
    beneficiary_uuid: asList(beneficiary_uuid),
    fiscal_quota_uuid: asList(fiscal_quota_uuid),
    fiscal_year: fiscal_year ? [Number(fiscal_year)] : undefined,
  };
}
